import clsx from "clsx";
import React, { InputHTMLAttributes } from "react";

import { InputError } from "../InputError";

import "./styles.css";

export interface RadioOption {
  label: string;
  value: string;
  description?: string;
  disabled?: boolean;
  customContent?: () => React.ReactNode;
  checked?: boolean;
  className?: string;
}

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  options: RadioOption[];
  className?: string;
  radioGroupClassName?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  color?: "brand-accent";
}

export const InputRadio = ({
  label,
  options,
  className,
  radioGroupClassName,
  onChange,
  value: selectedValue,
  errorMessage,
  color,
}: Props) => {
  return (
    <div className={clsx("input-radio flex w-full flex-col", className)}>
      {label && <b className="mb-1">{label}</b>}

      <div className={clsx("flex items-center gap-2 lg:gap-6", radioGroupClassName)}>
        {options.map(({ label: optionLabel, value, disabled, description, customContent, checked, className }) => (
          <div
            key={value}
            className={clsx(
              "input-radio-option-wrapper relative flex flex-row items-center",
              "transition-all duration-300",
              className,
            )}
          >
            <input
              id={value}
              type="radio"
              className={clsx(
                "absolute left-0 top-0 z-10 h-full w-full opacity-0",
                disabled ? "cursor-default" : "cursor-pointer",
              )}
              value={value}
              disabled={disabled}
              checked={checked ?? selectedValue === value}
              onChange={onChange}
            />

            <label
              htmlFor={value}
              className={clsx("flex items-center", color, {
                "opacity-50": disabled,
              })}
            >
              {!customContent && optionLabel}
            </label>

            {customContent?.()}

            {description && <span className="mt-2">{description}</span>}
          </div>
        ))}
      </div>

      <InputError message={errorMessage} />
    </div>
  );
};
